export default __webpack_public_path__ + "static/media/slide11.3a3f9199.jpeg";